/**
 * OLCI startup diagnostics (bootstrap, auth, load gate, data fetch).
 * Filter console logs with: OLCI-Startup
 * Remove by searching the repo for: authDebug or OLCI-Startup
 */
import { AuthService } from './auth.service';

export const OLCI_STARTUP_DEBUG_PREFIX = '[OLCI-Startup]';

export function authDebug(message: string, detail?: unknown): void {
    if (detail !== undefined) {
        console.info(`${OLCI_STARTUP_DEBUG_PREFIX} ${message}`, detail);
    } else {
        console.info(`${OLCI_STARTUP_DEBUG_PREFIX} ${message}`);
    }
}

export function authDebugSessionSnapshot(
    label: string,
    authService: AuthService,
    extras?: Record<string, unknown>
): void {
    authDebug(label, {
        isInitialized: authService.isInitialized.getValue(),
        hasAccessToken: !!authService.accessToken,
        accessTokenLength: authService.accessToken?.length ?? 0,
        hasSwidInMemory: !!authService.swid,
        pepAvailable: typeof (globalThis as any).PEP !== 'undefined' &&
            !!(globalThis as any).PEP?.PROFILE_AUTH,
        ...extras
    });
}
